import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';

import config from '@/core/config'

var opts = {
  apiKey: 'AIzaSyCFnH1IA10Y3twTmby5NhJuQ9Elhcoc9zY',
  authDomain: 'help4you-firebase.firebaseapp.com',
  databaseURL: 'https://help4you-firebase.firebaseio.com',
  projectId: 'help4you-firebase',
  storageBucket: 'help4you-firebase.appspot.com',
  messagingSenderId: '288801878116'
}
firebase.initializeApp(opts)

const database = firebase.database()
const storage = firebase.storage()
const dbRef = firebase.database().ref()
const storeRef = firebase.storage().ref()
const refLocations = database.ref('/locations');

export {
  database,
  storage,
  dbRef,
  storeRef,
  refLocations
}
